export default "__VITE_ASSET__sjw4_x1c__"